export default {
    setDrawer({ commit }, payload){
        commit('setDrawer', payload)
    },

    setDrawerColor({ commit }, payload){
        commit('setDrawerColor', payload)
    },

    setAppBarColor({ commit }, payload){
        commit('setAppBarColor', payload)
    },

    setLoadingScreen({ commit }, payload){
      commit('setLoadingScreen', payload)
    }
}
